/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-page-title[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
